var _path, _g, _path2, _g2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegulationBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 56,
    viewBox: "0 0 65 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 5.68629 2.68629 3 6 3H32C35.3137 3 38 5.68629 38 9V19C38 22.3137 35.3137 25 32 25H6C2.68629 25 0 22.3137 0 19V9Z",
    fill: "#FDE000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62490_54679)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 14,
    r: 5,
    fill: "#FFB005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5754 9.68292C13.771 9.36827 14.229 9.36827 14.4246 9.68292L19.5871 17.986C19.7942 18.3191 19.5547 18.75 19.1625 18.75H8.83747C8.44528 18.75 8.20577 18.3191 8.41285 17.986L13.5754 9.68292Z",
    fill: "#C2C2C2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 37C0 33.6863 2.68629 31 6 31H32C35.3137 31 38 33.6863 38 37V47C38 50.3137 35.3137 53 32 53H6C2.68629 53 0 50.3137 0 47V37Z",
    fill: "#FF95B2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_62490_54679)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 42,
    r: 5,
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5754 37.6829C13.771 37.3683 14.229 37.3683 14.4246 37.6829L19.5871 45.986C19.7942 46.3191 19.5547 46.75 19.1625 46.75H8.83747C8.44528 46.75 8.20577 46.3191 8.41285 45.986L13.5754 37.6829Z",
    fill: "#E52055"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2148 8.81793C43.1665 8.81793 46.1584 8.73811 49.1865 9.73492C52.2604 10.7468 55.29 12.8311 58.5049 16.9742C61.8665 21.3066 63.2223 25.9416 62.6572 30.3668C62.0928 34.7869 59.6284 38.8716 55.5879 42.1421C54.052 43.3853 51.4402 44.438 48.8398 45.2662C47.1115 45.8166 45.3217 46.2865 43.7305 46.6587L49.2588 50.3433C49.7182 50.6497 49.8424 51.2705 49.5361 51.73C49.2298 52.1894 48.6089 52.3136 48.1494 52.0074L40.6602 47.0162C40.2006 46.7099 40.0765 46.089 40.3828 45.6295L45.374 38.1402C45.6803 37.6807 46.3012 37.5566 46.7607 37.8629C47.2201 38.1692 47.3443 38.7901 47.0381 39.2496L43.4199 44.6773C44.9316 44.3206 46.6143 43.8756 48.2334 43.3599C50.8287 42.5333 53.1131 41.5717 54.3291 40.5875C58.0446 37.5801 60.1849 33.9341 60.6729 30.1138C61.16 26.2984 60.0157 22.1831 56.9248 18.1998C53.8961 14.2967 51.1757 12.4962 48.5605 11.6353C45.8996 10.7594 43.2632 10.8179 40.2148 10.8179C39.6626 10.8179 39.2148 10.3702 39.2148 9.81793C39.2149 9.26573 39.6626 8.81793 40.2148 8.81793Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62490_54679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_62490_54679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulationBadge);
export default __webpack_public_path__ + "static/media/regulationBadge.7c7c58cab34ab387896e3125e5565e49.svg";
export { ForwardRef as ReactComponent };